import styled, { css } from 'styled-components';

import Button from '../../../../ui/Atoms/Button';

import { Color } from '../../../constants/Colors';
import { FontSize, FontWeight } from '../../../constants/Fonts';
import { Indexes, MediaQuery } from '../../../constants/Styles';

export const MainContainer = styled.div`
  width: 100%;
  position: fixed;
  background-color: ${Color.WHITE};
  z-index: ${Indexes.MODAL};
`;

export const MainWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 10px 16px;
  display: flex;
  max-width: 1280px;
  margin: auto;
`;

export const NavigationWrapper = styled.div`
  display: flex;
  align-items: center;

  width: 100%;
  height: 100%;
`;

export const LogoLink = styled.a`
  height: 24px;

  border-radius: 50px;
  padding: 4px;
  margin-right: 13px;

  text-decoration: none;

  &:focus {
    outline: 2px solid ${Color.CLOUD_BURST};
    background-color: ${Color.WHISPER};
  }

  &:focus:not(:focus-visible) {
    outline: none;
    background-color: transparent;
  }
`;

export const Logo = styled.img`
  height: 24px;
`;

export const MenuLinksWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${MediaQuery.XL_AND_DOWN} {
    justify-content: flex-end;
  }
`;

export const MenuLinks = styled.div`
  ${MediaQuery.XL_AND_DOWN} {
    display: none;
  }
`;

export const LeadLinks = styled.div`
  display: flex;
  align-items: anchor-center;
`;

export const SearchBarWrapper = styled.div`
  display: flex;

  ${MediaQuery.L_AND_DOWN} {
    display: none;
  }
`;

export const ButtonWrapper = styled.div`
  margin-left: ${({ hasMargin }) => hasMargin && '10px'};

  a {
    margin-right: 10px;
    margin-left: ${({ isEvent }) => isEvent && '10px'};
  }

  display: ${({ isSearchBarDisplayed, isMobile }) =>
    isSearchBarDisplayed && isMobile ? 'none' : 'flex'};

  ${MediaQuery.M_AND_DOWN} {
    margin-left: 0;

    a {
      width: initial;
    }
  }
`;

export const HorizontalLine = styled.span`
  border-bottom: 1px solid ${Color.MYSTIC};
  display: block;
  margin: 0 auto;
  width: 100%;
`;

export const AdditionalLinkWrapper = styled.div`
  display: flex;
  align-items: center;

  ${MediaQuery.XL_AND_DOWN} {
    display: none;
  }
`;

export const VerticalLine = styled.span`
  border-left: 1px solid ${Color.HEATHER};
  height: 20px;
  margin: 0 auto;
  display: block;
  margin-left: 10px;
  margin-right: 10px;
`;

export const StyledSigninButton = styled(Button)`
  ${MediaQuery.S_AND_DOWN} {
    display: none;
  }
`;

export const styledNavButton = css`
  display: inline-flex;
  align-items: center;
  min-height: initial;
  width: fit-content;
  padding: 6px;

  cursor: pointer;
  pointer-events: initial;
  border: none;
  border-radius: 22.5px;
  background-clip: padding-box;
  box-sizing: border-box;

  background: ${Color.WHITE};
  color: ${Color.CLOUD_BURST};

  font-size: ${FontSize.XL};
  font-weight: ${FontWeight.BLACK};
  line-height: 22px;

  &:hover {
    color: ${Color.BLUE_RIBBON};
  }

  &:focus {
    outline: 2px solid ${Color.CLOUD_BURST};
    background: ${Color.WHISPER};
  }

  &:focus:not(:focus-visible) {
    outline: none;
    background-color: transparent;
  }
`;

export const BurgerButton = styled.button`
  ${styledNavButton};

  @media screen and (min-width: 1281px) {
    display: none;
  }
`;

export const CloseButton = styled.button`
  ${styledNavButton};
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${Color.WHITE};
  z-index: ${Indexes.MODAL};
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  flex-direction: column;

  @media screen and (min-width: 1281px) {
    display: none;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 17px 16px 15px 16px;
`;

export const MobileActionButtons = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 5px;

  a {
    width: 100%;
    justify-content: center;
  }
`;

export const Nav = styled.nav`
  overflow-y: auto;
  max-height: calc(100vh - 100px);
  -webkit-overflow-scrolling: touch; // support mobile touch scrolling on iOS Safari
`;
